import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const original = err.config;
    if (err.response?.status === 401 && !original._retry && !original.url.includes("/auth/")) {
      original._retry = true;
      try {
        await axios.post(`${API_BASE}/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch (_) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(detail) {
  if (!detail) return "Errore sconosciuto";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  return String(detail);
}

export const COMPANY_COLORS = {
  golmar: "#2563EB",
  vitam: "#D95319",
  rotta66: "#16A34A",
  fmg: "#7C3AED",
  all: "#334155",
};

export const COMPANY_LABELS = {
  golmar: "Golmar",
  vitam: "Vitam",
  rotta66: "ROTTA66",
  fmg: "Consorzio FMG",
  all: "Consolidato",
};

export const COMPANY_CODES = ["golmar", "vitam", "rotta66", "fmg"];

export const CATEGORIE_LABELS = {
  gasolio_dkv: "Gasolio DKV",
  gasolio_uta: "Gasolio UTA",
  gasolio_q8: "Gasolio Q8",
  telepass: "Telepass",
  leasing: "Leasing/Noleggi",
  assicurazione: "Assicurazioni",
  revisione: "Revisioni",
  tachigrafo: "Tachigrafo",
  satellitare: "Satellitare",
  multe: "Multe",
  gestione_aziendale: "Gestione aziendale",
  commercialista: "Commercialista/F24",
  contributi_busta_paga: "Contributi busta paga",
  altre_spese: "Altre spese",
  costi_carte_dispositivi: "Costi carte-dispositivi",
  fattura_cliente: "Fattura cliente",
  bonifico_diretto: "Bonifico diretto",
  bonifico_terzi: "Bonifico via terzi",
  cenibra: "Cenibra",
  giroconto: "Giroconto",
  pagamento_consumi: "Pagamento DKV/UTA/Q8/Telepass",
  anticipo_fatture: "Anticipo fatture",
  accantonamento: "Accantonamento (fondi)",
  commissioni_bancarie: "Commissioni bancarie",
  assegno_insoluto: "Assegno insoluto",
  imposte: "Imposte/F24 (rateizzazioni)",
  incasso_cliente: "Incasso cliente",
  incasso_intero: "Incasso intero al padroncino (IVA compresa)",
  contributi: "Contributi",
  non_classificato: "Non classificato",
};

export function fmtEur(v) {
  if (v == null || isNaN(v)) return "€ 0,00";
  const [int, dec] = Math.abs(v).toFixed(2).split(".");
  const abs = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + dec;
  return v < 0 ? `-€ ${abs}` : `€ ${abs}`;
}

const FLOTTA_RES = ["veicoli", "tessere", "scadenze"];
export function canWrite(user, resource) {
  if (!user || user.role === "sola_lettura") return false;
  if (user.role === "operatore_flotta") return FLOTTA_RES.includes(resource);
  return true;
}

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
    return d.toLocaleDateString("it-IT");
  } catch {
    return iso;
  }
}

export function fmtMese(mese) {
  if (!mese) return "";
  const mesi = ["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"];
  const [y, m] = mese.split("-");
  return `${mesi[parseInt(m) - 1]} ${y}`;
}

export function prevMese(mese) {
  if (!mese) return "";
  let [y, m] = mese.split("-").map(Number);
  m -= 1; if (m === 0) { m = 12; y -= 1; }
  return `${y}-${String(m).padStart(2, "0")}`;
}

export function currentCompetenzaMese() {
  const now = new Date();
  let m = now.getMonth(); // 0..11; -1 for prev
  let y = now.getFullYear();
  if (m === 0) { m = 12; y -= 1; } else { /* keep */ }
  return `${y}-${String(m).padStart(2, "0")}`;
}
